import AdminSpaces from '../../pages/spaces/AdminSpaces.vue';
import AdminSpace from '../../pages/spaces/AdminSpace.vue';
import AdminEditSpace from '../../pages/spaces/AdminEditSpace.vue';

import AdminSpaceFragments from '../../pages/spaces/AdminSpaceFragments.vue';
import AdminEditSpaceFragment from '../../pages/spaces/AdminEditSpaceFragment.vue';

export default [
  {
    path: '/v2/admin/spaces',
    name: 'admin.spaces.index',
    component: AdminSpaces,
    meta: {
      title: 'Spaces',
      //layout: 'content',
    },
  },
  {
    path: '/v2/admin/spaces/:spaceID(\\d+)',
    component: AdminSpace,
    children: [
      {
        path: 'edit',
        name: 'admin.space.edit',
        component: AdminEditSpace,
        meta: {
          title: 'Edit Space',
        }
      },
    ]
  },
  { // MLD-5030
    name: 'admin.space_fragments.index',
    path: '/v2/admin/spaces/fragments',
    component: AdminSpaceFragments,
  },
  {
    name: 'admin.space_fragment.edit',
    path: '/v2/admin/spaces/fragments/:fragmentID(\\d+)/edit',
    component: AdminEditSpaceFragment,
    meta: {
      title: 'Edit Space Fragment',
    }
  }
];
